<template>
  <footer class="footer">
    <div class="top-footer">
      <div class="content content-top-footer">
        <div class="wrapper-top-footer-logo" v-if="model.imageEnabled">
          <div v-if="model.imageEnabled" class="tenant-image">
            <img v-bind:src="model.image" tabindex="0" class="img-responsive" data-test-element="footer-image" v-bind:alt="model.footerLogoImgAlt"  />
          </div>
        </div>
        <div class="wrapper-top-footer">
          <ul class="link-footer-wrapper externalLink-footer-links">
            <li v-for="link in model.links" :key="link.text">
              <a target="_blank" rel="noopener noreferrer" :data-test-element="'footer-link-'+ link.footerLinkTypeToDisplay" class="external-link" :href="link.url" :title="link.tooltip">{{link.text}}</a>
            </li>
          </ul>
        </div>
        <div class="wrapper-top-footer">
          <ul class="externalLink-footer-wrapper externalLink-footer-links">
            <li v-for="(link, index) in model.externalLinks" v-if="index < 3" :key="link.text">
              <a :data-test-element="'external-link-'+ link.id" class="external-link" :data-target="'#' + link.id" data-toggle="modal" :href="link.url" :title="link.tooltip" v-on:click="showModal(link.id)" v-if="link.speedBumpRequired">{{link.text}}</a>
              <a target="_blank" rel="noopener noreferrer" :data-test-element="'external-link-'+ link.id" class="external-link" :href="link.url" :title="link.tooltip" v-if="!link.speedBumpRequired">{{link.text}}</a>
            </li>
          </ul>
        </div>
        <div class="wrapper-top-footer">
          <ul class="externalLink-footer-wrapper externalLink-footer-links">
            <li v-for="(link, index) in model.externalLinks" v-if="index >= 3" :key="link.text">
              <a :data-test-element="'external-link-'+ link.id" class="external-link" :data-target="'#' + link.id" data-toggle="modal" :href="link.url" :title="link.tooltip" v-on:click="showModal(link.id)" v-if="link.speedBumpRequired">{{link.text}}</a>
              <a target="_blank" rel="noopener noreferrer" :data-test-element="'external-link-'+ link.id" class="external-link" :href="link.url" :title="link.tooltip" v-if="!link.speedBumpRequired">{{link.text}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bottom-footer">
      <div class="content">
        <div>
          <img v-if="model.ncuaLogoEnabled" v-bind:src="model.ncuaLogoImage" tabindex="0" id="ncuaSvgObject" class="ncua-Logo fillColor" data-test-element="footer-NCUA" v-bind:class="{ 'forceNCUALogoMargin' : model.ehlLogoEnabled == false}"  alt="National Credit Union Administration"/>
          <img v-if="model.ehlLogoEnabled" v-bind:src="model.ehlLogoImage" tabindex="0" id="ehlSvgObject"  class="ehl-Logo fillColor" data-test-element="footer-EHL" v-bind:class="{ 'forceNCUALogoMargin' : model.ehlLogoEnabled == true}" alt="Equal Housing Lender" />
          <div v-if="model.additionalText" class="white-space-pre-wrap footer-additional-text additional-text-alignment" tabindex="0" v-html="model.additionalText" data-test-element="footer-additionalText"></div>
        </div>
        <div class="clearfix"></div>
        <div class="footer-copyright">
          <div class="white-space-pre-wrap" tabindex="0" v-html="model.copyright" data-test-element="footer-copyright"></div>
        </div>
        <div v-for="link in model.externalLinks" class="speed-bump modal fade" :id="link.id" tabindex="-1" role="dialog" style="display:none;">
          <div v-if="link.speedBumpRequired" class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title modal-title-long-text" data-test-element="external-link-title">{{link.text}}</h5>
                <a title="Close" class="close-button" data-dismiss="modal" :data-test-element="'close-modal-'+ link.id" v-on:click="hideModal(link.id)"><i class="material-icons">close</i></a>
              </div>
              <div class="modal-body">
                <alerts alert-context="terms"></alerts>
                <div class="modal-panel" :data-test-element="'externalLink-SpeedBumpMessage-txt'">
                  {{model.speedBumpText}}
                </div>
              </div>
              <div class="modal-footer">
                <a target="_blank" rel="noopener noreferrer" :href="link.url" autofocus="autofocus" class="button button-link" style="text-decoration:none;" :data-test-element="'externalLink-continue-link'" v-on:click="hideModal(link.id)">{{ $t('shared:action:continue') }}</a>
                <a class="button-secondary" data-dismiss="modal" :data-test-element="'externalLink-cancel-link'" v-on:click="hideModal(link.id)">{{ $t('shared:action:cancel') }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  import { routes } from '../routes';

  // TODO: Populate model with live configuration data.
  export default {
    data: () => ({
      model: {
        copyright: null,
        links: [],
        image: null,
        externalLinks: null,
        imageEnabled: false,
        speedBumpText: null,
        ehlLogoImage: null,
        ncuaLogoImage: null,
        ehlLogoEnabled: false,
        ncuaLogoEnabled: false,
      },
      routes: routes
    }),

    async mounted() {
      let response = await this.$http.get("footer", {});
      let regex = new RegExp(this.$appBase, "g");
      let tenantId = this.$hrefBase.replace(regex, '').replace(/\//g, '');
      let responseData = response.data;
      responseData.image = this.$appBase + "images?key=footerImage&tenantId=" + tenantId;
      responseData.ehlLogoImage = this.$appBase + "images?key=ehlLogoImage&tenantId=" + tenantId;
      responseData.ncuaLogoImage = this.$appBase + "images?key=ncuaLogoImage&tenantId=" + tenantId;
      responseData.footerLogoImgAlt = this.$t('shared:header:headerLogoImgAlt')
      this.model = responseData;
    },

    methods: {
      hideModal: function (linkId) {
        let popup = document.getElementById(linkId);
        let overlay = document.getElementById('overlay');
        popup.classList.remove('popup');
        popup.classList.add('fade');
        popup.style.display = "none";
        overlay.classList.remove('overlay');
      },
      showModal: function (linkId) {        
        let popup = document.getElementById(linkId);
        let overlay = document.getElementById('overlay');
        popup.classList.add('popup');
        popup.classList.remove('fade');
        popup.style.display = "block";
        overlay.classList.add('overlay');
      }
    }
  };
</script>